import { render, staticRenderFns } from "./attr-goods.vue?vue&type=template&id=7c22e347&scoped=true"
import script from "./attr-goods.vue?vue&type=script&lang=js"
export * from "./attr-goods.vue?vue&type=script&lang=js"
import style0 from "./attr-goods.vue?vue&type=style&index=0&id=7c22e347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_8b2b7732cc741d077553b84f33555b65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22e347",
  null
  
)

export default component.exports